module.exports = __webpack_public_path__ + "static/assets/7ce6b51fdb86dcf8b994bb5ddd9c666b.png";